import { render, staticRenderFns } from "./Inscript-Hindi-Lessons.vue?vue&type=template&id=6b37f107&"
import script from "./Inscript-Hindi-Lessons.vue?vue&type=script&lang=js&"
export * from "./Inscript-Hindi-Lessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports